import { FC } from 'react';
import { Col, Row } from 'antd';
import { TbCircleCheck, TbCircleX } from 'react-icons/tb';

import type { BillingEntitlementKey } from '@/constants';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import BillingEntitlementLink from '../BillingEntitlementLink';

export interface BillingEntitlementListItem {
    entitlementKey: BillingEntitlementKey;
    included?: boolean;
    label?: string;
}

export interface BillingEntitlementListProps {
    items: readonly BillingEntitlementListItem[];
}

const BillingEntitlementList: FC<BillingEntitlementListProps> = ({ items }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <>
            {items.map(({ entitlementKey, included = true, label }) => (
                <Row align='middle' gutter={[6, 4]} key={entitlementKey} wrap={false}>
                    <Col flex='none'>
                        {included ? (
                            <TbCircleCheck
                                aria-hidden='true'
                                fill={token.green2}
                                stroke={token.colorSuccess}
                                style={{ verticalAlign: '-0.175rem' }}
                            />
                        ) : (
                            <TbCircleX
                                aria-hidden='true'
                                fill={token.colorBorder}
                                stroke={token.colorBgTextActive}
                                style={{ verticalAlign: '-0.175rem' }}
                            />
                        )}
                    </Col>
                    <Col flex='auto' style={{ minWidth: 0 }}>
                        <small>
                            <BillingEntitlementLink entitlementKey={entitlementKey} label={label} />
                        </small>
                    </Col>
                </Row>
            ))}
        </>
    );
};

export default BillingEntitlementList;
